import { Box, Button, Heading, Input, Stack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.username, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="gray.100" p={4}>
      <Box w="full" maxW="sm" bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={6}>
          <Stack spacing={4}>
            <Box textAlign="center">
              <Heading size="lg">Riddhi Gold: Girvi</Heading>
              <Text color="gray.500">Girvi Management System</Text>
            </Box>
            {error && <Text color="red.500">{error}</Text>}
            <form onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <Input
                  name="username"
                  placeholder="Username"
                  value={form.username}
                  onChange={handleChange}
                  required
                />
                <Input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={form.password}
                  onChange={handleChange}
                  required
                />
                <Button type="submit" colorScheme="blue" isLoading={loading}>
                  Login
                </Button>
              </Stack>
            </form>
            <Text fontSize="sm" textAlign="center">
              Don&apos;t have an account? <Link to="/register">Register</Link>
            </Text>
          </Stack>
        </Box>
        <Box 
          position="fixed" 
          bottom={0} 
          left={0} 
          right={0} 
          p={4} 
          bg="gray.50" 
          borderTopWidth="1px" 
          borderColor="gray.200"
          textAlign="center"
        >
          <Text fontSize="xs" fontWeight="bold" color="gray.600">
            Powered by Riddhi Infotech
          </Text>
          <Text fontSize="xs" color="gray.500">
            <a href="http://www.riddhi-infotech.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>
              www.riddhi-infotech.com
            </a> | Email: <a href="mailto:sales@riddhi-infotech.com">sales@riddhi-infotech.com</a> | Mob: 7499391121
          </Text>
        </Box>
    </Box>
  );
};

export default Login;
